import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UploadFilesService {
  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;
  
  constructor(private http:HttpClient) { }

  public uploadFiles(files: FormData): Observable<any> {
    console.log(files);
    return this.http.post(`${this.REST_API_SERVER}/wfh/employee-upload`, files);
  }
  public getUserFiles(userId: string): Observable<any> {
    return this.http.get<any>(`${this.REST_API_SERVER}/wfh/get-user-files?user_id=${userId}`);
  }
}